<div class="invite">
  <div class="invite-header" *ngIf="step == 'step1' || step == 'step2'">
    <h2>{{ 'REGISTRATION.MODALITY.INVITE.TITLE' | translate }}</h2>
    <h4><b>{{ 'REGISTRATION.MODALITY.INVITE.TITLE2' | translate }}</b>
    {{ 'REGISTRATION.MODALITY.INVITE.SUBTITLE' | translate }}</h4>
  </div>
  <div class="row form">
    <div class="col-xs-12" *ngIf="step == 'step1'">
      <h4 class="title-invite">{{ 'REGISTRATION.MODALITY.INVITE.STEP1_TITLE' | translate }}</h4>
      <h4 class="subtitle-invite">{{ 'REGISTRATION.MODALITY.INVITE.STEP1_SUBTITLE' | translate }}</h4>
      <div class="kind-square col-md-5 col-xs-12" (click)="clickModality(1)">
        <img class="images-modality" src="../../../assets/shared/img/online.svg">
        <p>{{ 'REGISTRATION.MODALITY.INVITE.CHECKBOX1' | translate }}</p>
        <div class="checkbox-left">
          <div class="checkbox">
            <input type="checkbox">
            <i class="fa fa-check" [class.not-selected]="modalityChoosen == '2' || modalityChoosen == 'empty'"></i>
          </div>
        </div>
      </div>

      <div class="kind-square col-md-offset-1 col-md-5 col-xs-12" (click)="clickModality(2)">
        <img class="images-modality" src="../../../assets/shared/img/fisico.svg">
        <p>{{ 'REGISTRATION.MODALITY.INVITE.CHECKBOX2' | translate }}</p>
        <div class="checkbox-left">
          <div class="checkbox">
            <input type="checkbox">
            <i class="fa fa-check" [class.not-selected]="modalityChoosen == '1' || modalityChoosen == 'empty'"></i>
          </div>
        </div>
      </div>
      <button class="btn btn-warning navbar-btn invite" [disabled]="modalityChoosen == 'empty'" (click)="nextStep()">
          {{ 'REGISTRATION.MAIN.NEXT' | translate }}
      </button>
    </div>
  </div>
  <div class="responsive-columns step2" *ngIf="step == 'step2'">
    <h4 class="title-invite">{{ 'REGISTRATION.MODALITY.INVITE.STEP2_TITLE' | translate }}</h4>
    <form #formStep2="ngForm" (ngSubmit)="formStep2.valid && sendData(formStep2)">
      <div>
        <label> {{ 'REGISTRATION.MODALITY.INVITE.STEP2_FORM.INPUT1' | translate }}*
          <small class="errors-invite-form" *ngIf="(formStep2.submitted || establishment_name.touched) && !establishment_name.valid">{{ 'REQUIRED_FIELD' | translate }}</small>
          <br />
          <input name="establishment_name" placeholder="" type="text" class="form-control" [(ngModel)]="inviteData.establishment_name" #establishment_name="ngModel" required />
        </label>
      </div>
      <div *ngIf="modalityChoosen == '1'">
        <label>{{ 'REGISTRATION.MODALITY.INVITE.STEP2_FORM.INPUT2' | translate }}* <small class="errors-invite-form" *ngIf="(formStep2.submitted || url_website.touched) && !url_website.valid">{{ 'REQUIRED_FIELD' | translate }}</small>
          <br />
          <input name="url_website" type="text" class="form-control" placeholder="http://" [(ngModel)]="inviteData.url_website" #url_website="ngModel" required />
        </label>
      </div>
      <div *ngIf="modalityChoosen == '2'">
        <label>{{ 'REGISTRATION.MODALITY.INVITE.STEP2_FORM.INPUT3' | translate }}* <small class="errors-invite-form" *ngIf="(formStep2.submitted || address.touched) && !address.valid && !searching">{{ 'REQUIRED_FIELD' | translate }}</small>
          <img *ngIf="searching" src="assets/shared/img/svg/spinner.svg">
          <br />
          <div class="searchFor">
            <div class="content-input">
              <input type="text" name="address" class="form-control" [(ngModel)]="inviteData.address" placeholder="" #address="ngModel" required/>
            </div>
          </div>
        </label>
      </div>
      <div *ngIf="modalityChoosen == '1'">
        <label>{{ 'REGISTRATION.MODALITY.INVITE.STEP2_FORM.INPUT4' | translate }}<br />
          <input name="name" type="text" class="form-control" [(ngModel)]="inviteData.name" #name="ngModel"/>
        </label>
      </div>
      <div *ngIf="modalityChoosen == '2'">
        <label>{{ 'REGISTRATION.MODALITY.INVITE.STEP2_FORM.INPUT4' | translate }}* <small class="errors-invite-form" *ngIf="(formStep2.submitted || name.touched) && !name.valid">{{ 'REQUIRED_FIELD' | translate }}</small>
          <br />
          <input name="name" type="text" class="form-control" [(ngModel)]="inviteData.name" #name="ngModel" required/>
        </label>
      </div>
      <div>
        <label>{{ 'REGISTRATION.MODALITY.INVITE.STEP2_FORM.INPUT5' | translate }}* <small class="errors-invite-form" *ngIf="emailOrPhone">{{ emailOrPhone }}</small><br />
          <input name="email" type="email" class="form-control" [(ngModel)]="inviteData.email" #email="ngModel" pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,6})+$" />
          <small class="errors-invite-form" *ngIf="email.dirty && !email.valid">
            <i aria-hidden="true" class="fa fa-exclamation-triangle"></i>
            {{ 'EMAIL_IS_INVALID' | translate }}
          </small>
        </label>
      </div>
      <div>
        <label>{{ 'REGISTRATION.MODALITY.INVITE.STEP2_FORM.INPUT6' | translate }}* <small class="errors-invite-form" *ngIf="emailOrPhone">{{ emailOrPhone }}</small><br />
          <input [(ngModel)]="inviteData.phone" [textMask]="{mask: telephoneMask}" type="text" class="form-control" name="phone" #phone="ngModel">
        </label>
      </div>
      <div class="row-buttons">
        <button class="btn btn-outline-warning invite" (click)="step = 'step1'; trackingEvent('voltar')">{{ 'REGISTRATION.MAIN.BACK' | translate }}</button>
        <button class="btn btn-warning navbar-btn invite" type="submit">Enviar</button>
      </div>
      <small class="errors-invite-form request-error" *ngIf="errorMessage">
          <i aria-hidden="true" class="fa fa-exclamation-triangle"></i>
          {{errorMessage}}
      </small>
    </form>
  </div>
  <div class="invite-step3" *ngIf="step == 'step3'">
    <h1>{{ 'REGISTRATION.MODALITY.INVITE.STEP3_TITLE1' | translate }} <span>{{ 'REGISTRATION.MODALITY.INVITE.STEP3_TITLE2' | translate }}</span></h1>
    <h4>{{ 'REGISTRATION.MODALITY.INVITE.STEP3_SUBTITLE1' | translate }} <br> {{ 'REGISTRATION.MODALITY.INVITE.STEP3_SUBTITLE2' | translate }}</h4>
    <button class="btn btn-warning" (click)="step = 'step1'">{{ 'REGISTRATION.MODALITY.INVITE.STEP3_BTN' | translate }}</button>
  </div>
</div>
